import { Button, Flex, useDisclosure } from '@chakra-ui/react'
import { useState } from 'react'
import { ManualStornoModal } from './ManualStornoModal'
import { CancelledContractsModal } from '@/pages/steps/vehicle/stock/CancelledContractsModal'
import type { ManualStornoResponse } from '@/hooks/useWizard'

export const StornoPs = ({
  insuranceId,
  callback,
}: {
  insuranceId: number
  callback: (res: ManualStornoResponse) => void
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isResultOpen, onOpen: openResult, onClose: closeResult } = useDisclosure()
  const [result, setResult] = useState<ManualStornoResponse | null>(null)

  // callback se volá až při zavření přehledu výsledků (níže) — refetch po stornu přepne rodičovské tlačítko
  // na „Zrušit požadavek na storno", což by tuto komponentu i s otevřeným dialogem okamžitě odmountovalo.
  const handleSuccess = (res: ManualStornoResponse) => {
    setResult(res)
    openResult()
  }

  // Pokud bylo v rámci storna vytvořeno skladové pojištění, nabídneme proklik na jeho detail
  const stockDetailUrl = result?.stockInsuranceParamsId
    ? result.stockInsurerOfferId
      ? `/leasing/case/${result.stockInsuranceParamsId}/steps/complete/${result.stockInsurerOfferId}`
      : `/leasing/steps/complete/${result.stockInsuranceParamsId}`
    : undefined

  return (
    <Flex flexDir="column" gap={4} w="full">
      <Button variant="outline" colorScheme="red" onClick={onOpen}>
        Storno PS
      </Button>

      <ManualStornoModal
        insuranceId={insuranceId}
        isOpen={isOpen}
        onClose={onClose}
        onSuccess={handleSuccess}
      />

      {result && (
        <CancelledContractsModal
          contracts={result.cancelledContracts ?? []}
          isOpen={isResultOpen}
          onClose={() => {
            closeResult()
            // znovu načíst GetInsurance – u VWFS se stav smlouvy aktualizuje asynchronně
            callback(result)
          }}
          stockDetailUrl={stockDetailUrl}
        />
      )}
    </Flex>
  )
}
